import React from 'react';
import PropTypes from 'prop-types';

export default function StepList(props) {
  const { steps, step, onStepClick } = props;

  if (!steps) {
    return null;
  }

  const getStep = s => step === s.param;

  return (
    <div className="steps">
      <div className="row">
        {steps.map((s, index) => (
          <div key={s.title} className="step">
            {/* eslint-disable-next-line */}
            <a
              className={
                getStep(s)
                  ? 'btn btn-primary btn-circle active'
                  : 'btn btn-default btn-circle'
              }
              onClick={() => onStepClick(s.param)}
            >
              {index + 1}
            </a>
            <p>{s.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

StepList.propTypes = {
  steps: PropTypes.array,
  step: PropTypes.string,
  onStepClick: PropTypes.func,
};
